/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserSerialNumberEdit
 */
export interface MelcoModelsUserSerialNumberEdit {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserSerialNumberEdit
     */
    display_name?: string | null;
}

export function MelcoModelsUserSerialNumberEditFromJSON(json: any): MelcoModelsUserSerialNumberEdit {
    return MelcoModelsUserSerialNumberEditFromJSONTyped(json, false);
}

export function MelcoModelsUserSerialNumberEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserSerialNumberEdit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
    };
}

export function MelcoModelsUserSerialNumberEditToJSON(value?: MelcoModelsUserSerialNumberEdit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'display_name': value.display_name,
    };
}


